import z from "zod";

import { type CanvasSpecifier, canvasSpecifier } from "../api-types";

/**
 * Instructs the canvas metadata collab server to initialize: load the persisted canvas metadata
 * from the Moment GraphQL server (if this hasn't been done yet).
 */
export const initializeEvent = z.object({
	type: z.literal("initialize"),
	extra: z.object({
		authorizationHeader: z.nullable(z.string()),
		canvasSpecifier,
	}),
});

/**
 * Instructs the canvas metadata collab server to initialize: load the persisted canvas metadata
 * from the Moment GraphQL server (if this hasn't been done yet).
 */
export type InitializeEvent = z.infer<typeof initializeEvent>;

export function makeInitializeRequest(extra: {
	authorizationHeader: string;
	canvasSpecifier: CanvasSpecifier;
}): InitializeEvent {
	return { type: "initialize", extra };
}
